var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('MarketplaceProductsEditUser',{staticClass:"product-edit-left",attrs:{"MP":_vm.MP,"historyOfChanged":_vm.historyOfChanged,"categories":_vm.categories},on:{"save":function($event){return _vm.saveMarketplaceProduct(true)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }